import { Navbar, Footer, useReveal } from '../components/Balsuite';

const values = [
  { icon: '🎯', title: 'Clarity over complexity', desc: 'We build tools that make work simpler, not harder. Every feature earns its place.' },
  { icon: '🤝', title: 'Teams first', desc: 'Great products are built by great teams. We optimise for collaboration, trust, and autonomy.' },
  { icon: '🔒', title: 'Security by design', desc: 'Your data is yours. We build with privacy, security, and compliance baked in from the start.' },
  { icon: '🚀', title: 'Ship and iterate', desc: 'We learn from real-world use. Rapid iteration and honest feedback drive how we build.' },
];

export default function AboutPage() {
  useReveal();

  return (
    <div className="balsuite-page">
      <Navbar />
      <main style={{ maxWidth: '960px', margin: '0 auto', padding: '2rem 2rem 3rem' }}>

        {/* ── Hero header ── */}
        <div style={{ textAlign: 'center', marginBottom: '4rem' }}>
          <span className="sec-label reveal"
            style={{ display: 'inline-block' }}>About Us</span>
          <h1 className="sec-h2 reveal delay-1" style={{ marginTop: '0.5rem' }}>
            Built for teams that <span className="grad-text">mean business</span>
          </h1>
          <p className="sec-sub reveal delay-2"
            style={{ maxWidth: '560px', margin: '0.75rem auto 0' }}>
            Balsuite is a product by <strong>balvirt</strong> — a team of builders passionate
            about making work management simple, connected, and human.
          </p>
        </div>

        {/* ── Mission block ── */}
        <div className="reveal scale-up" style={{
          background: 'linear-gradient(135deg, rgba(99,102,241,0.06), rgba(139,92,246,0.06))',
          borderRadius: '20px', padding: '3rem', marginBottom: '3rem',
          border: '1px solid rgba(99,102,241,0.12)',
        }}>
          <h2 style={{ fontFamily: 'Bricolage Grotesque, sans-serif', fontSize: '1.5rem', fontWeight: 800, color: 'var(--t1)', marginBottom: '1rem' }}>
            Our mission
          </h2>
          <p style={{ fontSize: '1.05rem', color: 'var(--t2)', lineHeight: '1.8', maxWidth: '700px' }}>
            To replace the chaos of scattered tools — sticky notes, spreadsheets, Slack threads, and
            half-integrated apps — with one intelligent workspace where every team member, from intern
            to CEO, knows exactly what to do and how their work connects to the bigger picture.
          </p>
        </div>

        {/* ── Story ── */}
        <div style={{ marginBottom: '4rem' }}>
          <h2 className="reveal from-left"
            style={{ fontFamily: 'Bricolage Grotesque, sans-serif', fontSize: '1.5rem', fontWeight: 800, color: 'var(--t1)', marginBottom: '1.25rem' }}>
            The story
          </h2>
          <p className="reveal delay-1" style={{ color: 'var(--t2)', lineHeight: '1.8', marginBottom: '1rem' }}>
            Balsuite started from a simple frustration: the best engineering and HR teams we knew were
            drowning in tools. Projects lived in one place, timesheets in another, leave requests in
            email, and assets in a spreadsheet no one could find.
          </p>
          <p className="reveal delay-2" style={{ color: 'var(--t2)', lineHeight: '1.8' }}>
            We set out to build one platform that covers the full lifecycle of how a company runs —
            from onboarding a new hire to shipping a sprint to tracking every company laptop. Balsuite
            is that platform.
          </p>
        </div>

        {/* ── Values ── */}
        <h2 className="reveal"
          style={{ fontFamily: 'Bricolage Grotesque, sans-serif', fontSize: '1.5rem', fontWeight: 800, color: 'var(--t1)', marginBottom: '1.5rem' }}>
          What we stand for
        </h2>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(210px, 1fr))', gap: '1.25rem', marginBottom: '4rem' }}>
          {values.map((v, i) => (
            <div key={v.title}
              className={`reveal scale-up delay-${i + 1}`}
              style={{ padding: '1.75rem', border: '1px solid rgba(0,0,0,0.08)', borderRadius: '14px', background: '#fff' }}>
              <div style={{ fontSize: '1.75rem', marginBottom: '0.75rem' }}>{v.icon}</div>
              <h3 style={{ fontWeight: 700, fontSize: '0.95rem', color: 'var(--t1)', marginBottom: '0.5rem' }}>{v.title}</h3>
              <p style={{ fontSize: '0.875rem', color: 'var(--t2)', lineHeight: '1.6' }}>{v.desc}</p>
            </div>
          ))}
        </div>

        {/* ── CTA ── */}
        <div className="reveal scale-up"
          style={{ textAlign: 'center', padding: '2.5rem', background: 'var(--bg2)', borderRadius: '16px' }}>
          <h3 style={{ fontFamily: 'Bricolage Grotesque, sans-serif', fontWeight: 800, fontSize: '1.3rem', marginBottom: '0.75rem' }}>
            Want to work with us?
          </h3>
          <p style={{ color: 'var(--t2)', marginBottom: '1.5rem', fontSize: '0.9rem' }}>
            We're always looking for talented people who care about craft.
          </p>
          <a href="/careers">
            <button className="btn-gradient">View open roles →</button>
          </a>
        </div>

      </main>
      <Footer />
    </div>
  );
}
